require("./propertydata_changeby.js");
require("./propertydata_get.js");
require("./propertydata_set.js");
require("./propertydata_sprite.js");